export type SpaceCaseToCamelCase<S extends string> =
  S extends `${infer FirstWord} ${infer Rest}`
    ? `${Lowercase<FirstWord>}${Capitalize<SpaceCaseToCamelCase<Rest>>}`
    : Lowercase<S>

type _CamelCaseToSpaceCase<S extends string> =
  S extends `${infer First}${infer Rest}`
    ? First extends Uppercase<First>
      ? // If a character is uppercase, prepend a space and lowercase it.
        ` ${Lowercase<First>}${_CamelCaseToSpaceCase<Rest>}`
      : // Otherwise, keep the character as is.
        `${First}${_CamelCaseToSpaceCase<Rest>}`
    : S

export type CamelCaseToSpaceCase<S extends string> =
  S extends `${infer First}${infer Rest}`
    ? // Lowercase the first letter and then process the rest of the string.
      _CamelCaseToSpaceCase<`${Lowercase<First>}${Rest}`>
    : Lowercase<S>

export const spaceCaseToCamelCase = <
  TSpaceCase extends string | undefined | null,
>(
  spaceCase?: TSpaceCase
): TSpaceCase extends string
  ? SpaceCaseToCamelCase<TSpaceCase>
  : TSpaceCase => {
  if (!spaceCase || !spaceCase.includes(' ')) {
    return spaceCase as TSpaceCase extends string
      ? SpaceCaseToCamelCase<TSpaceCase>
      : TSpaceCase
  }

  return spaceCase
    .split(' ')
    .map((word, index) => {
      if (word === '') {
        return ''
      }

      if (index === 0) {
        return word.toLowerCase()
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('') as TSpaceCase extends string
    ? SpaceCaseToCamelCase<TSpaceCase>
    : TSpaceCase
}
